module.exports = __webpack_public_path__ + "img/domain_connected.65b22506.svg";